import {OptionValue} from "../../shared/OptionValue";

export const euCountryOptions: OptionValue[] = [
    {value: "AT", label: "AT (Austria)"},
    {value: "BE", label: "BE (Belgium)"},
    {value: "BG", label: "BG (Bulgaria)"},
    {value: "CH", label: "CH (Switzerland)"},
    {value: "CY", label: "CY (Cyprus)"},
    {value: "CZ", label: "CZ (Czech Republic)"},
    {value: "DE", label: "DE (Germany)"},
    {value: "DK", label: "DK (Denmark)"},
    {value: "EE", label: "EE (Estonia)"},
    {value: "ES", label: "ES (Spain)"},
    {value: "FI", label: "FI (Finland)"},
    {value: "FR", label: "FR (France)"},
    {value: "GB", label: "GB (United Kingdom)"},
    {value: "GR", label: "GR (Greece)"},
    {value: "HR", label: "HR (Croatia)"},
    {value: "HU", label: "HU (Hungary)"},
    {value: "IE", label: "IE (Ireland)"},
    {value: "IL", label: "IL (Israel)"},
    {value: "IT", label: "IT (Italy)"},
    {value: "LT", label: "LT (Lithuania)"},
    {value: "LU", label: "LU (Luxembourg)"},
    {value: "LV", label: "LV (Latvia)"},
    {value: "MT", label: "MT (Malta)"},
    {value: "NL", label: "NL (Netherlands)"},
    {value: "NO", label: "NO (Norway)"},
    {value: "PL", label: "PL (Poland)"},
    {value: "PT", label: "PT (Portugal)"},
    {value: "RO", label: "RO (Romania)"},
    {value: "RS", label: "RS (Serbia)"},
    {value: "SE", label: "SE (Sweden)"},
    {value: "SI", label: "SI (Slovenia)"},
    {value: "SK", label: "SK (Slovakia)"},
    {value: "UA", label: "UA (Ukraine)"},
];

export function destinationCountryOptionFromValue(value) {
    return euCountryOptions.find(option => option.value === value) || {value, label: value};
}

export const transportModeOptions: OptionValue[] = [
    {value: "AF", label: "AF (Airfreight)"},
    {value: "SE", label: "SE (Sea-Air)"},
    {value: "TR", label: "TR (Truck)"},
    {value: "VL", label: "VL (Vessel)"},
];

export const stpCodeOptions: OptionValue[] = [
    {value: "EU_CAS", label: "EU_CAS"},
    {value: "EU_EG", label: "EU_EG"},
    {value: "EU_GE", label: "EU_GE"},
    {value: "EU_GSP", label: "EU_GSP"},
    {value: "EU_JO", label: "EU_JO"},
    {value: "EU_MX", label: "EU_MX"},
    {value: "EU_TR", label: "EU_TR"},
    {value: "EU_VN", label: "EU_VN"},
    {value: "GB_GSP", label: "GB_GSP"},
    {value: "GB_VN", label: "GB_VN"},
];

export function stpCodeOptionFromValue(value) {
    return stpCodeOptions.find(option => option.value === value) || {value, label: value};
}
